(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/objectSpread", "@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/possibleConstructorReturn", "@babel/runtime/helpers/getPrototypeOf", "@babel/runtime/helpers/assertThisInitialized", "@babel/runtime/helpers/inherits", "@babel/runtime/helpers/defineProperty", "react", "prop-types", "noform", "../../context", "../../context/filter"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/objectSpread"), require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/possibleConstructorReturn"), require("@babel/runtime/helpers/getPrototypeOf"), require("@babel/runtime/helpers/assertThisInitialized"), require("@babel/runtime/helpers/inherits"), require("@babel/runtime/helpers/defineProperty"), require("react"), require("prop-types"), require("noform"), require("../../context"), require("../../context/filter"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectSpread, global.objectWithoutProperties, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.getPrototypeOf, global.assertThisInitialized, global.inherits, global.defineProperty, global.react, global.propTypes, global.noform, global.context, global.filter);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _extends2, _objectSpread2, _objectWithoutProperties2, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _getPrototypeOf2, _assertThisInitialized2, _inherits2, _defineProperty2, _react, _propTypes, _noform, _context, _filter) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectSpread2 = _interopRequireDefault(_objectSpread2);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _noform = _interopRequireWildcard(_noform);
  _filter = _interopRequireDefault(_filter);

  var Filter =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(Filter, _React$Component);

    function Filter(_props, context) {
      var _this;

      (0, _classCallCheck2.default)(this, Filter);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Filter).call(this, _props, context));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
        if (prevProps.cols !== _this.props.cols) {
          _this.setState({
            cols: _this.props.cols
          });
        }

        if (prevProps.autoWidth !== _this.props.autoWidth) {
          _this.setState({
            autoWidth: _this.props.autoWidth
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "search", function () {
        if (_this.grid) {
          _this.grid.core.search();
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clear", function () {
        if (_this.grid) {
          _this.grid.core.clearFilterData();
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderFilter", function (grid) {
        var gridCore = grid.core;

        if (!_this.grid && grid) {
          _this.grid = grid;
          window.grid = grid;
        }

        var _this$props = _this.props,
            _this$props$noDefault = _this$props.noDefaultLayout,
            noDefaultLayout = _this$props$noDefault === void 0 ? false : _this$props$noDefault,
            children = _this$props.children,
            render = _this$props.render,
            otherParent = (0, _objectWithoutProperties2.default)(_this$props, ["noDefaultLayout", "children", "render"]);
        var _this$state = _this.state,
            cols = _this$state.cols,
            autoWidth = _this$state.autoWidth;
        var core = gridCore.filterCore;

        var FilterBuiltin = function FilterBuiltin(props) {
          var className = props.className,
              propStyle = props.style,
              _props$direction = props.direction,
              direction = _props$direction === void 0 ? 'hoz' : _props$direction,
              autoWidth = props.autoWidth,
              cols = props.cols,
              _props$inset = props.inset,
              inset = _props$inset === void 0 ? false : _props$inset,
              others = (0, _objectWithoutProperties2.default)(props, ["className", "style", "direction", "autoWidth", "cols", "inset"]);
          var filterContextValues = noDefaultLayout ? {} : {
            cols: cols,
            autoWidth: autoWidth
          };
          var cls = className ? "".concat(className, " filter-area") : 'filter-area';
          var defaultStyle = noDefaultLayout ? {} : {
            display: 'inline-block',
            width: 'auto'
          };
          var style = (0, _objectSpread2.default)({}, defaultStyle, propStyle || {});
          return _react.default.createElement(_noform.default, (0, _extends2.default)({
            colon: false,
            className: cls,
            direction: direction,
            inset: inset,
            style: style,
            core: core
          }, others), _react.default.createElement(_filter.default.Provider, {
            value: filterContextValues
          }, children));
        };

        var builtinprops = (0, _objectSpread2.default)({}, otherParent);

        if (!noDefaultLayout) {
          builtinprops.cols = cols;
          builtinprops.autoWidth = autoWidth;
          builtinprops.inset = true;
        }

        var builtin = _react.default.createElement(FilterBuiltin, builtinprops);

        if (render && typeof render === 'function') {
          return render({
            children: children,
            builtin: builtin,
            DynamicBuiltin: FilterBuiltin,
            ctx: gridCore,
            search: _this.search,
            clear: _this.clear
          });
        }

        if (noDefaultLayout) {
          return _react.default.createElement(_react.default.Fragment, null, builtin);
        }

        return _react.default.createElement("div", {
          className: "filter-wrapper"
        }, builtin, _react.default.createElement("div", {
          className: "filter-control"
        }, _react.default.createElement("button", {
          className: "filter-control-query",
          onClick: _this.search
        }, "\u67E5\u8BE2"), _react.default.createElement("button", {
          className: "filter-control-clear",
          onClick: _this.clear
        }, "\u91CD\u7F6E\u7B5B\u9009\u6761\u4EF6")));
      });
      _this.grid = null;
      var _cols = _props.cols,
          _autoWidth = _props.autoWidth;
      _this.state = {
        cols: _cols,
        autoWidth: _autoWidth
      };
      return _this;
    }

    (0, _createClass2.default)(Filter, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(_context.Consumer, null, this.renderFilter);
      }
    }]);
    return Filter;
  }(_react.default.Component);

  (0, _defineProperty2.default)(Filter, "propTypes", {
    children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.array]),
    onSubmit: _propTypes.default.func,
    onReset: _propTypes.default.func,
    cols: _propTypes.default.number
  });
  (0, _defineProperty2.default)(Filter, "defaultProps", {
    cols: 3,
    autoWidth: false
  });

  var FilterItem = function FilterItem(props) {
    var _props$autoWidth = props.autoWidth,
        autoWidth = _props$autoWidth === void 0 ? true : _props$autoWidth,
        cols = props.cols,
        _props$colSpan = props.colSpan,
        colSpan = _props$colSpan === void 0 ? 1 : _props$colSpan,
        _props$noLayout = props.noLayout,
        noLayout = _props$noLayout === void 0 ? false : _props$noLayout,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className;
    var cls = "".concat(className, " nolist-filter-item");
    var style = props.style || {};
    var itemStyle = (0, _objectSpread2.default)({}, style);

    if (noLayout) {
      itemStyle.paddingRight = '0';
    } else if (cols && !autoWidth) {
      // priority: autoWidth > cols
      var width = (1 / Number(cols)).toFixed(2) * 100;
      var colWidth = Number(colSpan) * width;
      itemStyle.width = "".concat(colWidth, "%");
    }

    return _react.default.createElement(_noform.FormItem, (0, _extends2.default)({
      defaultMinWidth: false,
      full: true
    }, props, {
      className: cls,
      style: itemStyle
    }));
  };

  Filter.Item = function (props) {
    return _react.default.createElement(_filter.default.Consumer, null, function (_ref) {
      var cols = _ref.cols,
          autoWidth = _ref.autoWidth,
          others = (0, _objectWithoutProperties2.default)(_ref, ["cols", "autoWidth"]);
      return _react.default.createElement(FilterItem, (0, _extends2.default)({
        cols: cols,
        autoWidth: autoWidth
      }, others, props));
    });
  };

  Filter.If = _noform.If;

  Filter.Clear = function (props) {
    var render = props.render,
        children = props.children,
        style = props.style,
        others = (0, _objectWithoutProperties2.default)(props, ["render", "children", "style"]);
    return _react.default.createElement(_context.Consumer, null, function (grid) {
      var clear = function clear() {
        if (grid) grid.core.clearFilterData();
      };

      if (render) {
        return render(clear);
      }

      var defaultStyle = {
        style: (0, _objectSpread2.default)({
          cursor: 'pointer'
        }, style)
      };
      return _react.default.createElement("span", (0, _extends2.default)({
        onClick: clear
      }, defaultStyle, others), children);
    });
  };

  Filter.Search = function (props) {
    var render = props.render,
        children = props.children,
        style = props.style,
        others = (0, _objectWithoutProperties2.default)(props, ["render", "children", "style"]);
    return _react.default.createElement(_context.Consumer, null, function (grid) {
      var search = function search() {
        if (grid) grid.core.search();
      };

      if (render) {
        return render(search);
      }

      var defaultStyle = {
        style: (0, _objectSpread2.default)({
          cursor: 'pointer'
        }, style)
      };
      return _react.default.createElement("span", (0, _extends2.default)({
        role: "search",
        onClick: search
      }, defaultStyle, others), children);
    });
  };

  var _default = Filter;
  _exports.default = _default;
});